import React from "react";

const Columns = ({ openModalAdd }) => [
    {
        id: "id",
        name: "ID",
        minWidth: "60px",
        selector: (row) => row.id,
        cell: (row) => (
            <span className="text-[9px] font-mono text-cs-muted">
                #{row.id}
            </span>
        ),
    },
    {
        id: "name",
        name: "CARD HOLDER",
        minWidth: "160px",
        cell: (row) => (
            <div className="flex flex-col leading-tight">
                <span className="font-semibold text-cs-dark">
                    {row.name || row.card_name || "-"}
                </span>
                {row.alias && (
                    <span className="text-sm text-cs-primary">
                        {row.alias}
                    </span>
                )}
            </div>
        ),
    },
    {
        id: "card",
        name: "CARD",
        minWidth: "140px",
        cell: (row) => (
            <span className=" text-cs-muted">
                {row.card || "•••• •••• •••• ••••"}
            </span>
        ),
    },
    {
        id: "principal",
        name: "PRIMARY",
        minWidth: "90px",
        cell: (row) => {
            const isPrimary = !!row.principal;
            return (
                <span
                    className={`
                        px-2 py-0.5 rounded-full font-medium
                        inline-flex items-center gap-1
                        ${
                            isPrimary
                                ? "bg-cs-primary-soft text-cs-primary-dark"
                                : "bg-cs-bg-alt text-cs-muted border border-cs-border"
                        }
                    `}
                >
                    <span
                        className={`
                            w-1.5 h-1.5 rounded-full
                            ${isPrimary ? "bg-cs-primary" : "bg-cs-muted"}
                        `}
                    />
                    {isPrimary ? "Primary" : "Secondary"}
                </span>
            );
        },
    },
    {
        id: "actions",
        name: "",
        button: true,
        right: true,
        minWidth: "80px",
        cell: (row) => (
            <div className="flex items-center justify-end gap-1.5">
                {/* Placeholder delete (si luego agregas lógica real) */}
                <button
                    type="button"
                    onClick={() => console.log("Delete method", row.id)}
                    disabled={!row.can?.delete}
                    className={`
                        p-1.5 rounded-lg
                        transition-colors
                        ${
                            row.can?.delete
                                ? "text-cs-danger hover:bg-cs-danger/5"
                                : "text-cs-muted opacity-40 cursor-not-allowed"
                        }
                    `}
                    title={
                        row.can?.delete
                            ? "Delete method"
                            : "You cannot delete this method"
                    }
                >
                    <span className="material-symbols-outlined text-[16px]">
                        delete
                    </span>
                </button>
            </div>
        ),
    },
];

export default Columns;
